import { gql } from '@apollo/client'

import type { QueryVars, Filters } from '@/lib/apollo/query/getActivitiesForUser/query'

export type { QueryVars, Filters }

export type CompletedActivityResponse = {
  activityId: string
  subjectId: string
  details: string
  createdAt: string
}

export type Response = {
  getActivitiesForUser: {
    total: number
    offset: number
    results: CompletedActivityResponse[]
  }
}

const query = gql`
  query (
    $userId: String!
    $customerId: String!
    $startDate: String!
    $endDate: String!
    $limit: Int!
    $offset: Int!
    $filters: GetActivitiesForUserFilters
  ) {
    getActivitiesForUser(
      userId: $userId
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      total
      offset
      results {
        subjectId
        details
        createdAt
      }
    }
  }
`

export default query
